module.exports = __webpack_public_path__ + "img/fileClose.e6304995.svg";